module.exports = __webpack_public_path__ + "img/logo.8eff0f7f.png";